import { useState } from 'react';
import AccountLayout from '@/components/feature/AccountLayout';

export default function SettingsPage() {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    emailNotify: true,
    smsNotify: true,
    wechatNotify: false,
  });

  return (
    <AccountLayout
      activePath="/settings"
      contentClassName="space-y-6"
      breadcrumbs={[{ label: '账号中心', href: '/profile' }, { label: '安全设置' }]}
    >

      {/* Notification Settings */}
      <div className="glass-card rounded-2xl p-6 md:p-8">
        <h2 className="font-semibold text-foreground-950 text-sm mb-6">通知设置</h2>
        <div className="space-y-4 max-w-md">
          {[
            { key: 'emailNotify' as const, label: '邮件通知', desc: '接收审核结果、收益结算等重要通知' },
            { key: 'smsNotify' as const, label: '短信通知', desc: '接收合作线索提醒、紧急通知' },
            { key: 'wechatNotify' as const, label: '微信通知', desc: '通过微信公众号接收实时消息推送' },
          ].map((item) => (
            <div key={item.key} className="flex items-center justify-between p-4 rounded-xl bg-gray-50 border border-gray-200/60">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.label}</p>
                <p className="text-xs text-foreground-400">{item.desc}</p>
              </div>
              <button
                onClick={() => setFormData({ ...formData, [item.key]: !formData[item.key] })}
                className={`w-11 h-6 rounded-full transition-all cursor-pointer relative ${formData[item.key] ? 'bg-primary-500' : 'bg-background-300'
                  }`}
              >
                <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow-sm transition-all ${formData[item.key] ? 'left-[22px]' : 'left-0.5'
                  }`}></div>
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Danger Zone */}
      <div className="glass-card rounded-2xl p-6 md:p-8 border border-red-100/30">
        <h2 className="font-semibold text-red-600 text-sm mb-2">注销账号</h2>
        <p className="text-xs text-foreground-500 mb-4">注销后所有数据将被永久删除，此操作不可撤销</p>
        <button className="px-5 py-2.5 rounded-lg border border-red-200/60 text-red-600 text-sm font-medium hover:bg-red-50 transition-all cursor-pointer whitespace-nowrap">
          申请注销
        </button>
      </div>
    </AccountLayout>
  );
}